import { useMutation } from '@tanstack/react-query';
import { useRequestSections } from '../../../api/request';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/Store';
import Notifications from '../../../ui/molecules/toast/Notifications';
import { handleSendMessageStatus } from '../../../utils/helpers/usePostMessage';
import { clearAuditSaved } from '../../../redux/reducer/coreScriptReducer';
import { setShowSubmitDataError } from '../../../redux/reducer/contextIdReducer';
import { AxiosError } from 'axios';
import { useState } from 'react';
import useQueryObject from '../../../hooks/useQueryObject';

const useSaveData = () => {
  const { Save, EvaluateBilling } = useRequestSections();
  const dispatch = useDispatch();

  const contextId = useSelector(
    (state: RootState) => state.contextId.contextId
  );

  const useContextQueryObj = () => {
    return useSelector((state: RootState) => state.contextId.queryObj);
  };
  const queryObj = useContextQueryObj();
  const {
    isContextAddedIdReturned,
    isContextPerformBillingReview,
    orderNumber,
  } = useQueryObject();

  const {
    mutateAsync: postSubmitData,
    isPending: isSubmitDataPending,
    error: submitDataError,
    isSuccess: successfulSubmitData,
    isError: isSubmitDataError,
    data: submitData,
  } = useMutation<
    any,
    AxiosError,
    { parameter: any; AuditSaved: string | number; Followup: boolean }
  >({
    mutationFn: async ({ parameter, AuditSaved, Followup }) => {
      const response = await Save?.saveData(contextId, parameter);
      if (response?.status === 200) {
        const id = isContextAddedIdReturned
          ? `${response?.data?.addedContextId || queryObj?.id}`
          : `${queryObj?.id}`;

        if (isContextPerformBillingReview) {
          try {
            await EvaluateBilling.evaluateBilling(contextId, {
              OrderNumber: orderNumber,
            });
          } catch {
            // Billing review is best-effort and must not interrupt save completion until otherwise specified
          }
        }

        handleSendMessageStatus({
          SubmitComplete: true,
          Canceled: false,
          Context: `${queryObj?.context}`,
          ContextId: id,
          ContextKey: `${queryObj?.key}`,
          Followup: Followup,
          AuditSaved: AuditSaved,
          MessageType: response?.data?.messageType,
          Message: response?.data?.message,
        });
        dispatch(clearAuditSaved());
      }
      return response?.data;
    },
    onError: (err: AxiosError) => {
      dispatch(setShowSubmitDataError(true)); //forbidden dialog sets to false to clear otherwise will not be able to submit again
      Notifications(err?.message, 0);
    },
  });

  return {
    postSubmitData,
    isSubmitDataPending,
    submitDataError,
    isSubmitDataError,
    successfulSubmitData,
    submitData,
  };
};

export default useSaveData;
